export default __webpack_public_path__ + "static/media/plan-intentions.2c322e69.md";